// extracted by mini-css-extract-plugin
export default {"tabs":"YnnG2"};